import { createSelector } from 'reselect'
import { getSelectedFacets } from 'selectors/searchProvider'

export const getSelectedSize = createSelector(
  [getSelectedFacets],
  (selectedFacets): ReadonlyArray<string> => {
    return selectedFacets?.size || []
  }
)

export const getSelectedFacetsSizeMinMax = createSelector(
  [getSelectedFacets],
  (selectedFacets): Record<string, string | number> => {
    const [widthMin, widthMax] = (selectedFacets?.width?.[0] || '').split('-')
    const [heightMin, heightMax] = (selectedFacets?.height?.[0] || '').split('-')
    return {
      widthMin: widthMax ? Number(widthMin || '') : '',
      widthMax: Number(widthMax || ''),
      heightMin: heightMax ? Number(heightMin || '') : '',
      heightMax: Number(heightMax || ''),
    }
  }
)
